import clsx from 'clsx';
import React, { FC } from 'react';

interface CarouselIndicatorProps {
  active?: boolean;
  onClick?: () => void;
  customClassName?: string;
  darkBackground?: boolean;
}

const CarouselIndicator: FC<CarouselIndicatorProps> = ({
  active,
  onClick,
  customClassName = '',
  darkBackground = false,
}: CarouselIndicatorProps) => {
  const className = {
    defaultIndicatorClass: clsx(
      active && !darkBackground && 'bg-purple80 monochrome:bg-grey90',
      active && darkBackground && 'bg-green60 monochrome:bg-grey90',
      !active && 'bg-grey30',
      customClassName,
      `w-full h-5px border-0`
    ),
  };
  return (
    <li onClick={onClick} className="cursor-pointer w-full" aria-hidden="true">
      <div className={className.defaultIndicatorClass} />
    </li>
  );
};

export default CarouselIndicator;
